import { color, snap, units } from '@m/alchemy-theme';
import AlchemyPage from 'common/alchemyComponents/AlchemyPage';
import * as StyledAssignments from 'qa/alchemyAssignmentsPage/Styled';
import styled from 'styled-components';
import * as StyledComponents from 'common/alchemyComponents/index';
import { ArrowPreviousIcon } from '@m/alchemy-ui/icons/ArrowPreviousIcon';
import AlchemyDisplayBox from 'common/alchemyComponents/AlchemyDisplayBox';
import { Text } from '@m/alchemy-ui/Text';

export const Title = styled(StyledAssignments.Title)`
  margin-bottom: ${units(3)};
`;
export const Background = StyledComponents.Background;

export const ConfigurationPage = styled(AlchemyPage)`
  padding: 0 5vw ${units(4)};
  font-size: 14px;
  font-weight: normal;
`;

export const Container = styled.div`
  width: ${snap(800)};
  margin: 0 auto;
  padding-bottom: 72px;
`;

export const FixedArrowPreviousIcon = styled(ArrowPreviousIcon)`
  margin-bottom: -${units(0.5)};
`;

export const Section = styled(AlchemyDisplayBox)`
  margin-bottom: ${units(3)};
  padding: ${units(3)};
  width: 100%;
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${units(3)};
`;

export const SectionBody = styled.div`
  width: ${snap(560)};
  margin: 0 auto;
`;

export const IconWrapper = styled.div`
  padding: ${units(2)};
  background-color: ${color('hint', { palette: 'illustrativeCyan' })};
  border-radius: 50%;
`;

export const TermsAndConditionsTextCSS = styled(Text)`
  * {
    all: revert;
    padding: revert !important;
    margin: revert !important;
  }
  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }
  li {
    padding: inherit;
  }
  blockquote {
    border: 0 solid #ccc;
    border-left-width: 0.3em;
    margin-left: 0.3em !important;
    padding-left: 0.6em !important;
  }
`;
